import { reducerName } from './index'

/**
 * Retrive user preferences from the Redux store.
 * @param {Object} state - The Redux state object.
 * @returns {Object} - The user preferences.
 */
export const selectUserPreferences = state => state[reducerName]

export const selectUpdateUserPreferencesError = state => state[reducerName].error